import React from "react";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import { NidInquiryStatusType } from "../../../../enums/index";
import {
  DateToPersianNumber,
  ToPersianNumber,
} from "../../../../functions/index";
const SearchTable = (props) => {
  return (
    <Row>
      <Col>
        <Table responsive className="roundedCorners">
          <thead>
            <tr>
              {props.heading.map((h, index) => (
                <th key={index}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.searchData.CustomerSearchResult &&
              props.searchData.CustomerSearchResult.sort(
                (a, b) => b.ReadyDate - a.ReadyDate
              ).map((d, index) => (
                <tr
                  key={index}
                  onMouseOver={props.changeBackground}
                  onMouseOut={props.changeBackgroundBack}
                  onClick={() => {
                    props.setSearch(true);
                    props.setUserId(d.Id);
                    if (
                      d.NidInquiryStatus ===
                        NidInquiryStatusType.ReadyForInquiry() ||
                      d.NidInquiryStatus === NidInquiryStatusType.InProgress()
                    ) {
                      props.goToUserPage("authentication");
                    } else {
                      props.goToUserPage("user-info");
                    }
                  }}
                >
                  <td>{ToPersianNumber(index + 1)}</td>
                  <td>
                    {d.FisrtName} {d.LastName}
                  </td>
                  <td>
                    {d.NidInquiryStatus===0?
                    <span className="awaiting-authentication">در انتظار تکمیل اطلاعات</span>:
                    d.NidInquiryStatus===1 ?
                    <span className="awaiting-authentication">در انتظار احراز هویت</span>:
                    d.NidInquiryStatus===2?
                    <span className="awaiting-authentication">در حال برسی</span>:
                    d.NidInquiryStatus===3?
                    <span className="Identity-confirmed">تایید شده</span>:
                    d.NidInquiryStatus===4?
                    <span className="denied-identity">رد شده</span>:''
                  }
                  </td>
                  <td className="ltr">{ToPersianNumber(d.Mobile)}</td>
                  <td>{d.Email}</td>
                  {props.showAuthDate && (
                    <td>{DateToPersianNumber(d.PersianReadyDate)}</td>
                  )}
                  {props.showInquireDate && (
                    <td>{DateToPersianNumber(d.PersianAcceptedInquireDate)}</td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};
export default SearchTable;
